import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, ROLE_LABELS, formatDate } from "@/lib/api";
import { CheckCircle2, XCircle, Award } from "lucide-react";

export default function VerifyTessera() {
  const { number } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/public/tessera/verify/${number}`).then(r => setData(r.data)).catch(() => setData({ valid: false }));
  }, [number]);

  if (!data) return <div className="min-h-screen flex items-center justify-center">Caricamento…</div>;

  return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="verify-page">
      <div className="paper rounded-3xl p-8 max-w-md w-full text-center">
        {data.valid ? (
          <>
            <div className="w-20 h-20 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4">
              <CheckCircle2 className="w-12 h-12 text-emerald-600" />
            </div>
            <div className="text-xs uppercase tracking-widest text-emerald-700 font-bold">Tessera valida</div>
            {data.picture && <img src={data.picture} className="w-24 h-24 rounded-2xl mx-auto mt-4" alt="" />}
            <h1 className="font-display text-3xl font-bold text-[#2B3A33] mt-4">{data.name}</h1>
            <div className="mt-2 text-sm text-[#6B6558]">{data.association}</div>
            <div className={`role-${data.role || "tutti"} inline-block text-xs px-3 py-1 rounded-full font-semibold uppercase tracking-wide mt-3`}>
              {ROLE_LABELS[data.role] || data.role}
            </div>
            <div className="mt-6 flex items-center justify-center gap-2 text-sm">
              <Award className="w-4 h-4 text-[#D97706]" />
              <span className="font-mono font-bold">{data.tessera_number}</span>
            </div>
            <div className="text-xs text-[#6B6558] mt-2">
              Emessa {formatDate(data.issued_at)} · Valida fino al {formatDate(data.expires_at)}
            </div>
          </>
        ) : (
          <>
            <div className="w-20 h-20 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
              <XCircle className="w-12 h-12 text-[#EF3E36]" />
            </div>
            <div className="text-xs uppercase tracking-widest text-[#EF3E36] font-bold">Tessera non valida</div>
            <h1 className="font-display text-2xl font-bold text-[#2B3A33] mt-4">
              {data.message || "Tessera scaduta o non trovata"}
            </h1>
            <p className="text-sm text-[#6B6558] mt-2">Verifica il numero tessera o contatta l'Associazione.</p>
          </>
        )}
      </div>
    </div>
  );
}
